import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import ConnectPage from './ConnectPage';
import SuccessPage from './SuccessPage';
import HomePage from './HomePage';
import SupportPage from './SupportPage';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import videoBg from './mhc.mp4'; // Import the video

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <video autoPlay loop muted className="fixed top-0 left-0 w-full h-full object-cover z-0">
          <source src={videoBg} type="video/mp4" />
        </video>
        <div className="relative z-10 flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/connect" element={<ConnectPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* A default route can be added here if needed */}
          </Routes>
        </div>
        <footer className="relative z-10 bg-black/50 text-white text-center p-4">
          <Link to="/terms-of-use" className="mx-2">Terms of use</Link>
          <Link to="/privacy-policy" className="mx-2 hover:underline">Privacy Policy</Link>
        </footer>
      </div>
    </Router>
  );
}

export default App;